import Cookies from "js-cookie";
import { Recipe } from "../pages/recipe/recipe";
import { PLCTag } from "../pages/overview/models/PLCTag";

const apiUrl = process.env.REACT_APP_API_URL;
const apiCode = process.env.REACT_APP_API_CODE;

export async function fetchControllableTags(greenhouseId: string): Promise<PLCTag[] | undefined> {
    try {
        // Retrieve the token from cookies
        const token = Cookies.get('auth_token');

        const response = await fetch(`${apiUrl}/api/control?greenhouseId=${greenhouseId}&code=${apiCode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data: PLCTag[] = await response.json();
        return data;
    } catch (error) {
        console.error("Failed to fetch greenhouse data:", error);
        return undefined;
    }
}

export async function controlTag(greenhouseId: string, controlId: string, controlType: string, data: any): Promise<boolean | undefined> {
    try {
        // Retrieve the token from cookies
        const token = Cookies.get('auth_token');

        // Make the API call
        const response = await fetch(`${apiUrl}/api/control?greenhouseId=${greenhouseId}&controlId=${controlId}&controlType=${controlType}&code=${apiCode}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        return true;
    } catch (error) {
        console.error("Failed to fetch greenhouse data:", error);
        return undefined;
    }
}